import {
    createFileRoute,
    useLocation,
    useNavigate,
} from '@tanstack/react-router';

import { judgeTraceSearchSchema } from '@apps/web/features/admin_v3_judge/search_params';
import { JudgeTracePage } from '@apps/web/features/admin_v3_judge/trace_page';

export const Route = createFileRoute('/_app/admin/agent/judge/trace/$runId')({
    head: () => ({
        meta: [{ title: 'Trace | Judge | Internal Admin Agent' }],
    }),
    validateSearch: judgeTraceSearchSchema,
    component: JudgeTraceRoute,
});

function JudgeTraceRoute() {
    const { runId } = Route.useParams();
    const search = Route.useSearch();
    const hash = useLocation({ select: (location) => location.hash });
    const navigate = useNavigate({ from: Route.fullPath });
    return (
        <JudgeTracePage
            runId={runId}
            hash={hash}
            search={search}
            onHashChange={(next) =>
                void navigate({
                    hash: next,
                    search: true,
                    replace: true,
                    resetScroll: false,
                })
            }
            onOpenRun={(next) =>
                void navigate({
                    params: { runId: next.runId },
                    search: next.search,
                })
            }
        />
    );
}
